import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { isAuthenticated } from 'utils/auth';
import { APP_DEFAULT_PATH } from 'config';

// ==============================|| GUEST GUARD ||============================== //
// Keeps an already-logged-in admin off the login/register pages.

export default function GuestGuard({ children }) {
  if (isAuthenticated()) {
    return <Navigate to={APP_DEFAULT_PATH} replace />;
  }

  return children;
}

GuestGuard.propTypes = { children: PropTypes.node };
